module.exports = __webpack_public_path__ + "static/media/manzo_08_thumb_hover.6f9f8529.png";